<template>
  <button
    @click.stop.prevent="click()"
    class="text-gray-400 hover:text-bc-blue flex items-center gap-x-1 w-full"
  >
    <aw-icon icon="plus" class="relative w-4 h-4 "></aw-icon>
    {{ $t('Add new  row') }}
  </button>
  <!-- <aw-icon
    title="add color row"
    icon="table-row"
    class="
      w-4
      h-4
      cursor-pointer
      mr-0
      text-gray-400
      hover:text-gray-500
      
    "
    @click.stop.prevent="click()"
  ></aw-icon> -->
</template>

<script>
import BaseAddElement from '../../../mixins/BaseAddElement'
import fill from 'lodash/fill'

export default {
  mixins: [BaseAddElement],
  methods: {
    click() {
      this.addChild(
        'table-row',
        {
          cols: fill(
            Array(this.parent.data.headers.length),
            this.$t('Col value')
          )
        },
        [],
        {
          cols: fill(
            Array(this.parent.data.headers.length),
            this.$t('Col value')
          )
        }
      )
    }
  }
}
</script>
